<template>
  <app-modal
    v-bind="$attrs"
    class="confirm-modal-container"
    content-class="modal-error"
    title="CPA設定情報取得エラー"
  >
    <template v-slot:body>
      <!-- BODY -->
      <div class="modal-body msg-pre-line pa-4">
        CPA設定情報が存在しないため表示できません。設定情報を追加してください。
      </div>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="showCpa5gSaList" variant="outlined" color="primary"
              >CPA 5G SA一覧へ移動</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CpaAccessErrorModal",
  methods: {
    /** CPA 5G SA一覧取得 */
    async showCpa5gSaList() {
      await this.$router.push({
        path: "/remote/access",
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.msg-pre-line {
  white-space: pre-line;
}
</style>
